import React from 'react';
import Overview from './containers/analyse/Overview';
import Select from './containers/analyse/Select';
import InfoPage from './containers/analyse/InfoPage';
import Video from './containers/analyse/Video';

export const ROUTE_LOGIN = '/login';
export const ROUTE_SIGNUP = '/register';
export const ROUTE_FORGOT = '/forgot';
export const ROUTE_SET_PASSWORD = '/set-password';

export const ROUTE_DISCOVER = '/discover';
export const ROUTE_DISCOVER_QUESTIONNAIRE = '/discover/questionnaire';
export const ROUTE_DISCOVER_RESULT = '/discover/result';
export const ROUTE_DISCOVER_RESULT_PDF = '/discover/result/pdf';

export const ROUTE_ANALYSE = '/analyse';
export const ROUTE_ANALYSE_OVERVIEW = '/analyse/overview';
export const ROUTE_ANALYSE_SELECT = '/analyse/select';
export const ROUTE_ANALYSE_INFO = '/analyse/info';
export const ROUTE_ANALYSE_VIDEO = '/analyse/video';

export const ROUTE_TIPS = '/tips';
export const ROUTE_USERS = '/users';
export const ROUTE_PROFILE = '/profile';
/**
 * video overzicht - bouwstenen - video analyse
 */
const analyseRoutes = [
  {
    path: `${ROUTE_ANALYSE_OVERVIEW}/:videoAnalyseId?`,
    component: props => (
      <Overview videoAnalyseId={props.match.params.videoAnalyseId} />
    )
  },
  {
    path: `${ROUTE_ANALYSE_SELECT}/:videoAnalyseId/:analyseId?`,
    component: props => (
      <Select
        analyseId={props.match.params.analyseId}
        videoAnalyseId={props.match.params.videoAnalyseId}
      />
    )
  },
  {
    path: `${ROUTE_ANALYSE_INFO}/:videoAnalyseId/:analyseId`,
    component: props => (
      <InfoPage
        analyseId={props.match.params.analyseId}
        videoAnalyseId={props.match.params.videoAnalyseId}
      />
    )
  },
  {
    path: `${ROUTE_ANALYSE_VIDEO}/:videoAnalyseId/:analyseId`,
    component: props => (
      <Video
        videoAnalyseId={props.match.params.videoAnalyseId}
        analyseId={props.match.params.analyseId}
      />
    )
  }
];

export { analyseRoutes };



// WEBPACK FOOTER //
// ./src/RouteList.js